import { gfaFinancialDataServiceDefinition } from './gfa';
import { FinancialDataServiceV1Impl } from './v1';
import { Observer } from './v1/observer';
export * from './v1';
export const financialDataServiceDefinition = {
    id: 'financial-data',
    create() {
        const observer = new Observer(undefined);
        return {
            '1.0.1': () => ({
                featureService: new FinancialDataServiceV1Impl(observer)
            })
        };
    }
};
export const defineFinancialDataService = () => financialDataServiceDefinition;
export const financialDataServiceDefinitions = [
    financialDataServiceDefinition,
    gfaFinancialDataServiceDefinition
];
